
export const DISCOUNT_APPROVING_SETTINGS = {
    discountServicePropsService: 'discount',
    discountServicePropsApprovalStateName: 'approval_state',
    discountServicePropsApprovalStateDisplayedValue: 'in_progress',

    discountRefreshEvent: 'discount-approving-refresh-event'
}

export enum DiscountTypes {
    ZTP = 'ztp',
    TEACHER = 'teacher',
    STUDENT = 'student',
    BLIND = 'blind',
    RETIREE = 'retiree'
}
